import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PagerDisplayMode } from 'devextreme/common/grids';
import config from 'devextreme/core/config';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { loadMessages, locale } from 'devextreme/localization';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf';
import { Observable, Subject } from 'rxjs';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import esMessages from "../../assets/i18n/devextreme/es.json";
import { OptionMenuEnum, PermissionEnum, ScreenEnum, UserFunctionsEnum } from '../enumerators/enumerators.enum';
import { OptionEnum } from '../enumerators/messages.enum';
import { DialogOption } from '../models/dialog-option.model';
import { UserPermissionView } from "../models/user-permission-view.model";

import { Language } from '../models/language.model';
import { LocalPermission } from '../models/local-permission.model';
import { MenuOption } from '../models/menu-option.model';
import { Option } from '../models/option.model';
import { Parameter } from '../models/parameter.model';
import { PermissionsScreen } from '../models/permission-screen';
import { Person } from '../models/person.model';
import { User } from '../models/user.model';


@Injectable()
export class SystemService {


  private devExtremeLicenseKey = "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImI3ZDMzZmZmLTk1NGYtMTFlNi04MGQ1LTAwMTU1ZDYyNDgwYiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.QtfUkCYu1cLkD9xDat/0ZhJ7pU57MLca5cZPVI/DAnl0c2vcqyB/uwroGXPV6TXZT0y/r3P7LRGuA/v/6FxlhzL/1qgvPKv5JBDnoHD32RVXTsTXUVXCZkCZl6jUb/tEZelESw==";

  private body : HTMLElement = document.body;
  private html: HTMLElement = document.getElementById('html')!;

  public user: User = new User({});
  userDataSubject = new Subject<User>();
  languagesSubject = new Subject<Array<Language>>();

  public loadedPermissions: boolean = false;
  public loadedInitialData: boolean = false;

  public numeroControl: number = 0;

  permissions?: Array<LocalPermission>;
  screens: Array<any> = [];

  public selectedLanguage: Language = new Language({});
  languages: Array<Language> = [];
  parameters: Array<Parameter> = [];

  public configLanguages: Array<string> = ["es"];
  public defaultLanguage: string = "es";

  public localStoreVariable: any;

  public controlId = 0;

  public controlClassMd = "col-12 sm:col-6 md:col-4 lg:col-4";
  public controlClassLg = "col-12 sm:col-6 md:col-3 lg:col-3";

  //--- Expresiones Regulares ----
  NombrePersonalER = /^(([A-Z]|Ñ|[a-z]|[ñáéíóú]|[ÁÉÍÓÚ]){2,120}\s?)+$/;
  CorreoER = new RegExp("^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,3})$");
  PasswordER = new RegExp("^((?=.*\\d)(?=.*[secret-z])(?=.*[A-Z]).{6,20})$");
  PasswordTemporalER = new RegExp("^.{6,}$");
  TelefonoER = new RegExp("^\\([1-9][0-9]{2}\\) [0-9]{3}.[0-9]{4}$");
  TarjetaER = new RegExp("^[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}$");
  RFCMoralER = new RegExp("^(([ÑA-Z|ña-z|&amp;]{3}|[A-Z|a-z]{3})\\d{2}((0[1-9]|1[012])(0[1-9]|1\\d|2[0-8])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31)(\\w{2})([A|a|0-9]{1}))$|^(([ÑA-Z|ña-z|&amp;]{3}|[A-Z|a-z]{4})([02468][048]|[13579][26])0229)(\\w{2})([A|a|0-9]{1})$");
  RFCFisicaER = new RegExp("^(([ÑA-Z|ña-z|&amp;]{4}|[A-Z|a-z]{4})\\d{2}((0[1-9]|1[012])(0[1-9]|1\\d|2[0-8])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31)(\\w{2})([A|a|0-9]{1}))$|^(([ÑA-Z|ña-z|&amp;]{3}|[A-Z|a-z]{4})([02468][048]|[13579][26])0229)(\\w{2})([A|a|0-9]{1})$");
  RFCER = new RegExp("^(([ÑA-Z|ña-z|&amp;]{3,4}|[A-Z|a-z]{3,4})\\d{2}((0[1-9]|1[012])(0[1-9]|1\\d|2[0-8])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31)(\\w{2})([A|a|0-9]{1}))$|^(([ÑA-Z|ña-z|&amp;]{3}|[A-Z|a-z]{4})([02468][048]|[13579][26])0229)(\\w{2})([A|a|0-9]{1})$");
  NumeroNominaER = new RegExp("^[0-9]{6}$");
  ZipCodeER = new RegExp("^[0-9]{5}$");
  DecimalER = new RegExp("^[0-9]+([.][0-9]{1,2})?$");
  AmounER = new RegExp("^\$([0-9]{1,3}(?:,([0-9]{3}))*)(\.\d+)?$");
  UrlER = new RegExp("^(https?:\\/\\/)?([a-zA-Z0-9]([a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,6}(\\/?|[\\/\\?\\#].*)?$");

  //------ Mascaras -----------
  phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/,/\d/, ' ', /\d/,/\d/,/\d/,/\d/];
  ZipCodeMask = [/\d/,/\d/,/\d/,/\d/,/\d/];
  cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  payrollNumberMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  rfcEmpresaMask = [/[a-zA-Z]/i, /[a-zA-Z]/i, /[a-zA-Z]/i, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /[a-zA-Z0-9]/i, /[a-zA-Z0-9]/i, /[a-zA-Z0-9]/i];

  //------ Animaciones ----------
  openModalAnimation: string = "fadeInUp";
  closeModalAnimation: string = "fadeOutUp";

  //mascara
  integerNumberMask = createNumberMask(
    {
      prefix: '',
      suffix: '',
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol: '',
      allowDecimal: false,
      decimalSymbol: '',
      decimalLimit: 0,
      integerLimit: null,
      requireDecimal: false,
      allowNegative: false,
      allowLeadingZeroes: false
    });

  decimalNumberMask = createNumberMask(
    {
      prefix: '',
      suffix: '',
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol: '',
      allowDecimal: true,
      decimalSymbol: '.',
      decimalLimit: null,
      integerLimit: null,
      requireDecimal: false,
      allowNegative: false,
      allowLeadingZeroes: false
    });

  kfmaSK = createNumberMask(
    {
      prefix: 'KF',
      suffix: '',
      includeThousandsSeparator: false,
      thousandsSeparatorSymbol: '',
      allowDecimal: false,
      decimalSymbol: '',
      decimalLimit: 0,
      integerLimit: 3,
      requireDecimal: false,
      allowNegative: false,
      allowLeadingZeroes: true
    });

  // tablas
  public tablePaginationMode: PagerDisplayMode = "full";
  public tablePagination = 10;
  public tablePaginationNavigation = true;
  public tablePaginationInfo = true;
  public tablePaginationSelector = true;
  public tablePaginationPageSize = [10, 25, 50, 100];

  //letiables
  public linkValue: number = 0;

  // Variables globales
  public menuOptions: Array<MenuOption> = [];
  public homeMenu: Array<MenuOption> = [];
  public activePath: string = "";
  public currentScreen: MenuOption = new MenuOption();
  public screenDetails : Array<UserPermissionView> = []

  public controlNumber: number = 0;

  constructor(private translateService: TranslateService, private datePipe: DatePipe) {
    this.getActiveValue = this.getActiveValue.bind(this);
    this.localStoreVariable =
    {
      Lenguaje: "Lenguaje",
      Paginacion: "Paginacion",
      JWT: "Secret",
      SideBarFijo: "SideBarFijo",
      LenguajeCambiado: "LenguajeCambiado",
      UsuarioEnmascarado: "UsuarioEnmascarado",
      SesionValida: "SesionValida",
      AOT: "AOT",
      Servicios: "Servicios"
    };

    if (localStorage.getItem(this.localStoreVariable.Paginacion)) {
      this.tablePagination = parseInt(localStorage.getItem(this.localStoreVariable.Paginacion) as string);
    }

    // idioma
    translateService.addLangs(this.configLanguages);
    translateService.setDefaultLang(this.defaultLanguage);
    translateService.use(this.defaultLanguage);

    loadMessages(esMessages);
    locale(this.defaultLanguage);

    // Licencia de Devextreme
    let license = this.getDevExtremeLicenseKey();
    config({ licenseKey: license });
  }

  // ------- Idioma -------
  changeLanguage(idiomaClave: string) {
    localStorage.setItem(this.localStoreVariable.Lenguaje, idiomaClave);
    window.location.reload();
  }

  getDevExtremeLicenseKey() {
    return this.devExtremeLicenseKey;
  }

  setLanguages() {
    var languages: Array<string> = [];
    var defaultLanguage: string = "";

    var userLanguage = localStorage.getItem(this.localStoreVariable.Lenguaje);
    var activeUserLanguage = false;

    this.languages.forEach(language => {
      languages.push(language.keyCode!);

      if (language.predetermined) {
        defaultLanguage = language.keyCode!;
      }

      if (language.keyCode === userLanguage) {
        activeUserLanguage = true;
      }
    });
    this.translateService.addLangs(languages);
    this.translateService.setDefaultLang(defaultLanguage);

    // Emitir los idiomas cargados
    this.languagesSubject.next(this.languages);

    if (userLanguage && activeUserLanguage) {
      this.translateService.use(userLanguage).subscribe(() => {
        this.setSelectedLanguage();
      });

      locale(userLanguage);
    }
    else {
      // Si no hay idioma guardado en localStorage, usar el idioma por defecto y guardarlo
      if (!userLanguage && defaultLanguage) {
        localStorage.setItem(this.localStoreVariable.Lenguaje, defaultLanguage);
      }

      locale(defaultLanguage);
      this.translateService.use(defaultLanguage).subscribe(() => {
        this.setSelectedLanguage();
      });
    }
  }

  setSelectedLanguage() {
    this.languages.forEach((idioma: Language) => {
      if (idioma.keyCode === this.translateService.currentLang) {
        this.selectedLanguage = idioma;
      }
    });
  }

  // ------- Permisos ------
  getPermissions() {
    return this.permissions;
  }

  hasAccess(screen: ScreenEnum) : boolean
  {
    if (screen == ScreenEnum.Ninguno)  {
      return true;
    }else{
      return !!this.screenDetails.find(screenDetail => screenDetail.screenKeyCode == screen);
    }
  }

  hasPermission(screen : ScreenEnum, permission : PermissionEnum, onlyTI : boolean = false) : boolean
  {
    if(onlyTI && this.screenDetails.find(screenDetail => screenDetail.screenKeyCode == screen && screenDetail.permissionKeyCode == PermissionEnum.TI) == undefined){
      return false;
    }else if(this.screenDetails.find(screenDetail => screenDetail.screenKeyCode == screen && (screenDetail.permissionKeyCode == PermissionEnum.Administrar || screenDetail.permissionKeyCode == PermissionEnum.TI))){
      return true;
    }else{
      return !!this.screenDetails.find(screenDetail => screenDetail.screenKeyCode == screen && screenDetail.permissionKeyCode == permission);
    }
  }

  getPermissionByScreen(screen: ScreenEnum): PermissionsScreen{

    let permissions: PermissionsScreen = new PermissionsScreen({});

    permissions.manage = this.hasPermission(screen, PermissionEnum.Administrar);
    permissions.read = this.hasPermission(screen, PermissionEnum.Consultar);
    permissions.add = this.hasPermission(screen, PermissionEnum.Agregar);
    permissions.edit = this.hasPermission(screen, PermissionEnum.Editar);
    permissions.delete = this.hasPermission(screen, PermissionEnum.Eliminar);
    permissions.export = this.hasPermission(screen, PermissionEnum.Exportar);

    return permissions;

  }

  //----------------- User ----------------

  setUser(user: User) {
    this.user = user;
    this.userDataSubject.next(user);
  }

  getUser(): Observable<User> {
    return this.userDataSubject.asObservable();
  }

  getLanguages(): Observable<Array<Language>> {
    return this.languagesSubject.asObservable();
  }

  // ------------- menú --------
  setUserMenu() {
    //  Uusario opciones  --------------------------
    this.menuOptions.push(new MenuOption(
      {
        title: this.user.person?.name,
        icon: "assets/icons/svg/usuarioPerfil.svg",
        moduleType: OptionMenuEnum.Module,
      }));

    this.menuOptions[this.menuOptions.length - 1].subMenu.push(new MenuOption(
      {
        title: this.translateService.instant("Perfil.CambiarPassword"),
        icon: "assets/icons/svg/cambiarPassword.svg",
        function: UserFunctionsEnum.ChangePassword,
        moduleType: OptionMenuEnum.Function,
      }
    ));

    this.menuOptions[this.menuOptions.length - 1].subMenu.push(new MenuOption(
      {
        title: this.translateService.instant("Perfil.CerrarSesion"),
        icon: "assets/icons/svg/logout.svg",
        function: UserFunctionsEnum.LogOut,
        moduleType: OptionMenuEnum.Function,
      }
    ));

    if (this.user.maskedUser) {
      this.menuOptions[this.menuOptions.length - 1].subMenu.push(new MenuOption(
        {
          title: this.translateService.instant("Perfil.CerrarSesionEnmascarado"),
          icon: "assets/icons/svg/cerrarEnmascarado.svg",
          function: UserFunctionsEnum.LogOutMask,
          moduleType: OptionMenuEnum.Function,
        }
      ));
    }
  }

  getHomeMenu() {
    this.homeMenu = [];

    this.homeMenu = this.homeMenu.concat(this.menuOptions.filter(item => item.homeScreen));

    this.menuOptions.forEach(opcion => {
      if (opcion.subMenu !== undefined && opcion.subMenu.length > 0) {
        this.homeMenu = this.homeMenu.concat(opcion.subMenu.filter(item => item.homeScreen));

        opcion.subMenu.forEach(submenu => {
          if (submenu.subMenu.length > 0) {
            this.homeMenu = this.homeMenu.concat(submenu.subMenu.filter(item => item.homeScreen));
          }
        });
      }
    });

    this.homeMenu.sort((itemA: MenuOption, itemB: MenuOption) => {
      if (itemA.homeOrder > itemB.homeOrder) {
        return 1;
      }
      else if (itemA.homeOrder < itemB.homeOrder) {
        return -1;
      }

      return 0;
    });

  }

  activateOptionMenu(url: string) {
    this.menuOptions?.map(optionA => {
      if (optionA.path == url) {
        optionA.isActive = true;

        this.activePath = optionA.title;
        this.currentScreen = optionA;
      }
      else {
        optionA.isActive = false;
      }

      optionA.subMenu.forEach(optionB => {
        if (optionB.path == url) {
          optionB.isActive = true;
          optionA.isActive = true;

          this.activePath = optionA.title + " > " + optionB.title;
          this.currentScreen = optionB;
        }
        else {
          optionB.isActive = false;
        }

        optionB.subMenu.forEach(optionC => {
          if (optionC.path == url) {
            optionC.isActive = true;
            optionB.isActive = true;
            optionA.isActive = true;

            this.activePath = optionA.title + " > " + optionB.title + " > " + optionC.title;
            this.currentScreen = optionC;
          }
          else {
            optionC.isActive = false;
          }
        });
      });
    });
  }

  changeTablePagination(event: any) {
    if (event.fullName == "paging.pageSize") {
      this.tablePagination = event.value;
      localStorage.setItem(this.localStoreVariable.Paginacion, event.value);
    }
  }

  //---------- Fechas -------
  string2Date(date: any) {
    if (date) {
      return new Date(date.slice(0, 4), parseInt(date.slice(5, 7)) - 1, date.slice(8, 10));
    }
    else {
      return null;
    }
  }

  string2DateControl(date: any) {
    if (date) {
      let year = parseInt(date.slice(0, 4));
      let mes = parseInt(date.slice(5, 7)) - 1;
      let dia = parseInt(date.slice(8, 10));

      return { date: { year: year, month: mes + 1, day: dia }, jsdate: new Date(year, mes, dia) };
    }
    else {
      return null;
    }
  }

  generateFolio(prefix: string, length: number, id: number) {
    // pad with zeros using padLeft, examploe id  is 8, length is 5, result is 00008, and prefix is FREQ, result is FREQ-00008
    return prefix + "-" + id.toString().padStart(length, "0");
  }

  date2String(val: any) {
    if (val) {
      let mes = val.date.month;
      let dia = val.date.day;

      if (mes < 10) {
        mes = "0" + mes;
      }

      if (dia < 10) {
        dia = "0" + dia;
      }

      return val.date.year + "-" + mes + "-" + dia;
    }
    else {
      return "";
    }
  }

  date2StringRange(val: any) {
    if (val) {
      let mes = val.month;
      let dia = val.day;

      if (mes < 10) {
        mes = "0" + mes;
      }

      if (dia < 10) {
        dia = "0" + dia;
      }

      return val.year + "-" + mes + "-" + dia;
    }
    else {
      return "";
    }
  }

  string2DateRange(date: any) {
    if (date) {
      let year = parseInt(date.slice(0, 4));
      let mes = parseInt(date.slice(5, 7));
      let dia = parseInt(date.slice(8, 10));

      return { year: year, month: mes, day: dia };
    }
    else {
      return { year: "", month: "", day: "" };
    }
  }

  string2DatePicker(date: any) {
    if (date) {
      var year = parseInt(date.slice(0, 4));
      var mes = parseInt(date.slice(5, 7)) - 1;
      var dia = parseInt(date.slice(8, 10));

      return { date: { year: year, month: mes + 1, day: dia }, jsdate: new Date(year, mes, dia) };
    }
    else {
      return null;
    }
  }

  date2DateRange(date: any) {
    if (date) {
      let year = date.getFullYear();
      let mes = date.getMonth() + 1;
      let dia = date.getDate();

      return { year: year, month: mes, day: dia };
    }
    else {
      return null;
    }
  }

  englishDateToSpanishDate(fecha: string) {
    let day = fecha.slice(8, 10);
    let month = fecha.slice(5, 7);
    let year = fecha.slice(0, 4);

    return day + "-" + month + "-" + year;
  }

  spanishDateToEnglisDate(fecha: string) {
    let year = fecha.slice(6, 10);
    let month = fecha.slice(3, 5);
    let day = fecha.slice(0, 2);

    return year + "-" + month + "-" + day;
  }

  getToDayEnglish() {
    let fecha = new Date();
    let month = fecha.getMonth() + 1;
    let day = fecha.getDate();

    return fecha.getFullYear() + "-" + (month < 10 ? ("0" + month) : month) + "-" + (day < 10 ? ("0" + day) : day);
  }

  clearSessionData() {
    // Limpiar todas las variables del localStorage relacionadas con la sesión
    localStorage.removeItem(this.localStoreVariable.AOT);
    localStorage.removeItem(this.localStoreVariable.Servicios);
    localStorage.removeItem(this.localStoreVariable.JWT);
    localStorage.removeItem(this.localStoreVariable.SesionValida);
    localStorage.removeItem(this.localStoreVariable.UsuarioEnmascarado);
    localStorage.removeItem(this.localStoreVariable.LenguajeCambiado);

    // Resetear estado de la aplicación
    this.loadedPermissions = false;
    this.loadedInitialData = false;
    this.permissions = [];
    this.user = new User({});
    this.menuOptions = [];
    this.screens = [];
  }

  //-----
  getExitOptions() {
    let opciones = [];

    opciones.push(new DialogOption({ title: this.translateService.instant("Salir"), value: 1 }));
    opciones.push(new DialogOption({ title: this.translateService.instant("Cancelar"), value: 2, type: OptionEnum.Negative }));

    return opciones;
  }

  getDeleteOptions() {
    let opciones = [];

    opciones.push(new DialogOption({ title: this.translateService.instant("Eliminar"), value: 1 }));
    opciones.push(new DialogOption({ title: this.translateService.instant("Cancelar"), value: 2, type: OptionEnum.Negative }));

    return opciones;
  }

  removeAccents(str: string): string {
    var accents = 'àáâãäçèéêëìíîïñòóôõöùúûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜÝ';
    var reAccents = new RegExp('[' + accents + ']', 'g');
    var replacements = 'aaaaaceeeeiiiinooooouuuuyyAAAAACEEEEIIIINOOOOOUUUUY';
    return str.replace(
      reAccents,
      function (match) {
        return replacements[accents.indexOf(match)];
      }
    );
  };

  // borrar elemento arreglo
  deleteItem(lista: Array<any>, elemento: any, propiedad: string) {
    for (let k = 0; k < lista.length; k++) {

      if (lista[k][propiedad] == elemento[propiedad]) {
        lista.splice(k, 1);
        break;
      }
    }
  }

  deleteItemValue(list: Array<any>, item: any, property: string) {
    for (let k = 0; k < list.length; k++) {
      if (list[k][property] == item) {
        list.splice(k, 1);
        break;
      }
    }
  }

  deleteItemValueByValue(list: Array<string>, item: string) {
    for (let k = 0; k < list.length; k++) {
      if (list[k] == item) {
        list.splice(k, 1);
        break;
      }
    }
  }

  getEntityById(entities: any, id: any, attribute: string) {
    for (let entitie of entities) {
      if (entitie[attribute] == id) {
        return entitie;
      }
    }

    return null;
  }

  getRelated(id: any, list: Array<any>, attribute: string) {
    return list.filter(p => {
      return p[attribute] == id;
    });
  }

  getParameterValue(key: string) {
    for (let parameter of this.parameters) {
      if (parameter.keyCode == key) {
        return parameter.valueData;
      }
    }

    return null;
  }

  getUserValue(person: Person) {
    return person.name + (person.surname ? (" " + person.surname) : '') + (person.secondSurname ? (" " + person.secondSurname) : '');
  }

  computePercentage(value: number, total: number) {
    let porcentage = Math.round((value * 10000.00) / total);

    return (porcentage / 100).toFixed(2);
  }

  getActiveValue(data: any) {
    if (data.Activo) {
      return this.translateService.instant("Si");
    }
    else {
      return this.translateService.instant("No");
    }
  }

  getDateValue(data: any, parameter: string) {
    return this.datePipe.transform(data[parameter], this.translateService.instant("FormatoFechaHora"));
  }

  hasValue(valor: any): boolean {
    if (valor || valor === 0 || valor === false) {
      return true;
    }
    else {
      return false;
    }
  }

  hasArrayValue(valor: any): boolean {
    if (valor && valor.length > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  openPanelFixed() {
    this.body.classList.add('freezePage');
    this.html.classList.add('freezePage');
  }

  closePanelFixed() {
    this.body.classList.remove('freezePage');
    this.html.classList.remove('freezePage');
  }

  openInternalPanelFixed() {
    this.openPanelFixed();

    let sidebar = document.getElementById('sidebarApp');
    let header: HTMLElement = document.getElementById('encabezadoApp')!;

    sidebar!.classList.add('panelFondo');
    header!.classList.add('panelFondo');
  }

  closeInternalPanelFixed() {
    this.closePanelFixed();

    let sidebar = document.getElementById('sidebarApp');
    let header: HTMLElement = document.getElementById('encabezadoApp')!;

    sidebar?.classList.remove('panelFondo');
    header?.classList.remove('panelFondo');
  }

  removeAccentsNFD(data: string): string {
    return data.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  getWeekDays(locale: string) {
    let baseDate = new Date(Date.UTC(2017, 0, 3)); // just a Monday
    let weekDays: Array<Option> = [];
    for (let index = 1; index <= 7; index++) {
      let weekDay = baseDate.toLocaleDateString(locale, { weekday: 'long' });
      weekDays.push({ id: index, name: weekDay.charAt(0).toUpperCase() + weekDay.slice(1) });
      baseDate.setDate(baseDate.getDate() + 1);
    }

    return weekDays;
  }

  getWeekDayName(date: Date, locale: string) {
    return date.toLocaleDateString(locale, { weekday: 'long' });
  }






  /**
   * Generates a random string of the specified length.
   *
   * @param length - The length of the random string to generate.
   * @param onlyNumbers - Specifies whether the random string should contain only numbers.
   * @returns The randomly generated string.
   */
  generateRandomString(length: number, hasMayus: boolean, hasMinus: boolean): string {
    let result = '';
    let characters = '0123456789';

    if (hasMayus) {
      characters += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    }

    if (hasMinus) {
      characters += 'abcdefghijklmnopqrstuvwxyz0123456789';
    }

    let charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  // SAVE CONTENT FUNCTIONS
  public AbrirSavePantalla(){}

  public CerrarSavePantalla(){}

  public AbrirPanelFixed()
  {
    this.body.classList.add('freezePage');
    this.html.classList.add('freezePage');
  }

  public CerrarPanelFixed() {
    this.body.classList.remove('freezePage');
    this.html.classList.remove('freezePage');
  }

  public AbrirPanelInteriorFixed()
  {
    this.AbrirPanelFixed();

    let sidebar : HTMLElement = document.getElementById('sidebarApp')!;
    let header : HTMLElement = document.getElementById('encabezadoApp')!;

    sidebar?.classList.add('panelFondo');
    header?.classList.add('panelFondo');
  }

  public CerrarPanelInteriorFixed() {
    this.CerrarPanelFixed();

    let sidebar : HTMLElement = document.getElementById('sidebarApp')!;
    let header : HTMLElement = document.getElementById('encabezadoApp')!;

    sidebar!.classList.remove('panelFondo');
    header!.classList.remove('panelFondo');
  }

  /**
   * Método genérico para exportar DataGrid a Excel
   * @param event - Evento del DataGrid
   * @param fileName - Nombre del archivo (sin extensión)
   */
  public exportToExcel(event: any, fileName: string): void {
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Data');

    exportDataGrid({
      component: event.component,
      worksheet,
      autoFilterEnabled: true,
      customizeCell: (options: any) => {
        if (options.gridCell.rowType == 'data' && options.gridCell.column.dataType === 'boolean') {
          if (options.gridCell.value === true || options.gridCell.value === 'true' || options.gridCell.value === 1) {
            options.excelCell.value = 'Sí';
          } else if (options.gridCell.value === false || options.gridCell.value === 'false' || options.gridCell.value === 0) {
            options.excelCell.value = 'No';
          }
        }
        // Usar el valor calculado si existe
        else if(options.gridCell.rowType == 'data' && options.gridCell.column.calculateCellValue) {
          const calculatedValue = options.gridCell.column.calculateCellValue(options.gridCell.data, options.gridCell.column);
          options.excelCell.value = calculatedValue;
        }
      }
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer: any) => {
        const fullFileName = fileName + '.xlsx';
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fullFileName);
      });
    });
  }

  /**
   * Método genérico para exportar DataGrid a PDF
   * @param event - Evento del DataGrid o instancia del componente
   * @param fileName - Nombre del archivo (sin extensión)
   */
  public exportToPdf(event: any, fileName: string): void {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });
    const component = event.component || event;
    
    exportDataGridToPdf({
      jsPDFDocument: doc,
      component: component,
      customizeCell: (options: any) => {
        const { pdfCell, gridCell } = options;
        if (gridCell.rowType === 'data' && gridCell.column.dataType === 'date') {
          if (gridCell.value) {
            const date = new Date(gridCell.value);
            pdfCell.text = date.toLocaleDateString('es-ES');
          }
        }
      }
    }).then(() => {
      doc.save(`${fileName}.pdf`);
    });
  }
}

